import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
class Tabbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: this.props.currentPage,
      initialToggle: false,
    };
  }

  componentDidUpdate() {
    if (!this.state.initialToggle && this.props.currentPage) {
      this.toggleClasses(document.getElementById(this.props.currentPage));
      this.setState({ currentPage: this.props.currentPage, initialToggle: true });
    }
  }

  componentDidMount() {
    if (!this.state.initialToggle && this.props.currentPage) {
      this.toggleClasses(document.getElementById(this.props.currentPage));
      this.setState({ currentPage: this.props.currentPage, initialToggle: true });
    }
  }

  toggleClasses(element) {
    if (element) {
      element.classList.toggle('text-blue-600');
      element.classList.toggle('border-blue-600');
    }
  }

  handler = (event, contract) => {
    this.props.setContract(contract);
    this.toggleClasses(document.getElementById(this.state.currentPage));
    this.toggleClasses(document.getElementById(event.target.id));
    this.setState({ currentPage: event.target.id });
  };

  render() {
    const list = this.props.list ? this.props.list : new Array(4).fill({});
    return (
      <div className={this.props.classes}>
        <div className='border-b border-gray-200'>
          <nav className='-mb-px flex justify-start w-full' aria-label='Tabs'>
            {list.map((item, index) => {
              return (
                <span
                  key={item.text || index}
                  onClick={(e) => {
                    this.handler(e, item);
                  }}
                  id={item.text}
                  className={`border-transparent ${this.props.titleClasses ? this.props.titleClasses : 'py-3'} text-gray-500 border-b hover:text-blue-600 hover:border-blue-600 mr-10 text-center font-semibold text-base cursor-pointer`}
                >
                  {item.text || <Skeleton width={100} height={25} />}
                </span>
              );
            })}
          </nav>
        </div>
      </div>
    );
  }
}

Tabbar.defaultProps = {
  classes: '',
};

export default Tabbar;
